import { useEffect, useState } from 'react';
import api from '../../services/api';

function moneyCents(cents) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
}

export default function ReferralShareSection() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    api
      .get('/auth/referral/me')
      .then((res) => {
        if (!cancelled && res.data?.success) setStats(res.data.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.message || 'Could not load referral program');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const copyLink = async () => {
    if (!stats?.shareUrl) return;
    try {
      await navigator.clipboard.writeText(stats.shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      setCopied(false);
    }
  };

  if (loading) return <p>Loading referral program…</p>;
  if (error) return <p className="profile-error">{error}</p>;
  if (!stats) return null;

  return (
    <div className="referral-share-section" style={{ maxWidth: 560 }}>
      <h2 style={{ marginTop: 0 }}>Refer a friend</h2>
      <p style={{ color: '#64748b' }}>
        Share your link. When friends create an account, you earn credit toward{' '}
        {moneyCents(stats.defaultRewardCents)} per qualified referral (managed by the dealership).
      </p>
      <div style={{ margin: '16px 0', padding: 16, background: '#f8fafc', borderRadius: 8 }}>
        <div style={{ fontSize: 13, color: '#64748b' }}>Your referral code</div>
        <div style={{ fontSize: 24, fontWeight: 700, letterSpacing: 2 }}>{stats.referralCode}</div>
        <div style={{ marginTop: 12, wordBreak: 'break-all', fontSize: 14 }}>{stats.shareUrl}</div>
        <button type="button" className="btn-primary" style={{ marginTop: 12 }} onClick={copyLink}>
          {copied ? 'Copied!' : 'Copy invite link'}
        </button>
      </div>
      <div className="metrics-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
        <div><strong>{stats.totalReferrals}</strong><div style={{ fontSize: 13, color: '#64748b' }}>Total referrals</div></div>
        <div><strong>{stats.qualifiedReferrals}</strong><div style={{ fontSize: 13, color: '#64748b' }}>Qualified</div></div>
        <div><strong>{stats.rewardedReferrals}</strong><div style={{ fontSize: 13, color: '#64748b' }}>Rewarded</div></div>
      </div>
    </div>
  );
}
